import { downloadFile, openPdfInNewTab } from "@/utils/fileConvert";
import api from "./ProdPurchaseApi";
import globalStore from "@/models/GlobalStore";
import { t } from "@/plugins/i18n";

export class ProdPurchaseStore {

  //---------- PDF ----------//
  async printProdPurchasePdf(invoiceId: number) { //Vételi jegy megnyitása új lapon
    await api.printProdPurchasePdf(invoiceId)
      .then((response) => {
        openPdfInNewTab(response);
      });
  }

  async downloadProdPurchasePdf(invoiceId: number) { //Vételi riport jegy letöltése
    await api.printProdPurchasePdf(invoiceId)
      .then((response) => {
        downloadFile(response, t("ProdPurchase_FelvasarlasiJegy", [invoiceId]), globalStore.fileType.pdf);
      });
  }
}

const store = new ProdPurchaseStore();
export default store;